


let grArtSwiper;

// Gửi vị trí iframe quayso (Frame3+Frame4) xuống iframe để popup bên trong định vị đúng vùng
// đang xem. Dùng postMessage nên chạy được cả khác origin / file:// (không cần same-origin).
window.addEventListener("load", function () {
  const iframe = document.getElementById("omg3q-quayso");
  if (!iframe) return; // chỉ có ở trang cha (bundle main cũng nằm trong iframe → tự bỏ qua)

  const send = function () {
    if (!iframe.contentWindow) return;
    const rect = iframe.getBoundingClientRect();
    iframe.contentWindow.postMessage({
      __quaysoViewport: true,
      top: rect.top,
      width: rect.width,
      parentHeight: window.innerHeight
    }, "*");
  };

  window.addEventListener("scroll", send, { passive: true });
  window.addEventListener("resize", send);
  iframe.addEventListener("load", send);
  send();
});

// ===== INTRO: phát clip mở màn khi load, chạy hết clip thì tắt intro & hiện main =====
window.addEventListener("load", function () {
  if (window.innerWidth <= 768) return; // chỉ PC (mobile không có intro)

  const introEl = document.querySelector(".intro");
  const video = introEl && introEl.querySelector("video");

  // Hiện main + mở scroll (gọi khi intro kết thúc hoặc không có intro)
  function showMain() {
    document.querySelectorAll(".main, .MS__outer, .floating_popup")
      .forEach(function (el) { el.classList.add("active"); });
    document.documentElement.classList.remove("close_scroll");
    document.body.classList.remove("intro-active");
    window.dispatchEvent(new Event("resize"));
  }

  // Không có intro/video → vào thẳng main
  if (!introEl || !video) {
    showMain();
    return;
  }

  // Bật intro, khóa scroll, ẩn main trong lúc clip chạy
  introEl.classList.add("active");
  document.body.classList.add("intro-active");
  document.documentElement.classList.add("close_scroll");

  // Kết thúc intro: chỉ chạy 1 lần (clip xong, lỗi, hoặc trình duyệt chặn autoplay)
  let ended = false;
  function endIntro() {
    if (ended) return;
    ended = true;
    introEl.remove();
    showMain();
  }

  video.addEventListener("ended", endIntro);
  video.addEventListener("error", endIntro);

  // Muted để vượt chặn autoplay; nếu vẫn không phát được thì bỏ intro luôn
  video.muted = true;
  const playPromise = video.play();
  if (playPromise && typeof playPromise.catch === "function") {
    playPromise.catch(endIntro);
  }
});

/* ĐÃ TẠM ĐÓNG INTRO — animation intro (gsap) comment lại, mở lại khi cần:
window.addEventListener("load", function () {
  // 👉 Chỉ chạy trên PC
  if (window.innerWidth <= 768) return;

  const today = new Date().toISOString().split("T")[0]; // ví dụ: "2025-08-04"
  const storedDate = localStorage.getItem("introShownDate");
  //const intro = document.querySelector(".intro");
  const main = document.querySelector(".main");
 const outer = document.querySelector(".MS__outer");
 const popup = document.querySelector(".floating_popup");

  if (!intro || !main) return;

  // 👉 Nếu intro đã hiển thị hôm nay
  if (storedDate === today) {
  intro.remove();
document.body.classList.remove("intro-active"); // 👉 THÊM DÒNG NÀY
  intro.classList.add("active");
  main.classList.add("active");
  outer.classList.add("active");
 popup.classList.add("active");
  document.documentElement.classList.remove("close_scroll");
  
  window.dispatchEvent(new Event('resize')); // 👉 Thêm ở đây


  //initSwiper();
  return;
}

  // ✅ Lưu ngày intro đã chạy
  localStorage.setItem("introShownDate", today);

  // 👉 Kích hoạt intro
  intro.classList.add("active");
document.body.classList.add("intro-active"); // 👉 THÊM DÒNG NÀY

  main.classList.remove("active");
  outer.classList.remove("active");
popup.classList.remove("active");
  document.documentElement.classList.add("close_scroll"); // Thêm class vào <html>

  const tl = gsap.timeline();
  let textHidden = false;
  let animationShown = false;
  const gifts = document.querySelectorAll(".gift");

  gsap.set(".animation", { opacity: 0, visibility: "hidden" });
  gsap.set(gifts, {
    opacity: 0,
    scale: 0.8,
    x: 0,
    y: 0,
    display: "none"
  });

  tl.from(".text-left", {
    opacity: 0,
    scale: 0.5,
    duration: 0.5,
    ease: "back.out(1.7)"
  })
    .from(".text-right", {
      opacity: 0,
      scale: 0.5,
      duration: 0.5,
      ease: "back.out(1.7)"
    })
    .to(".gr_letter--left", {
      rotateY: -165,
      duration: 1,
      transformOrigin: "3% 50%",
      ease: "power2.inOut",
      onUpdate: function () {
        const progress = this.progress();

        if (progress > 0.15 && !textHidden) {
          textHidden = true;
          document.querySelector(".text-left").style.display = "none";
          document.querySelector(".text-right").style.display = "none";
        }

        if (progress > 0.3 && !animationShown) {
          animationShown = true;
          document.querySelector(".btn_letter")?.classList.add("active");

          gsap.to(".animation", {
            opacity: 1,
            visibility: "visible",
            duration: 0.5,
            ease: "power1.out"
          });

          continuousExplosionsWithGifts(2000, 40, 300);
        }
      }
    }, "+=0.3")
    .to(".gr_letter--right", {
      rotateY: 165,
      duration: 1,
      transformOrigin: "97% 50%",
      ease: "power2.inOut"
    }, "<");
});
*/

function continuousExplosionsWithGifts(durationMs = 2000, particlesPerBlast = 30, interval = 300) {
  const start = Date.now();
  const gifts = Array.from(document.querySelectorAll(".gift"));
  let giftIndex = 0;

  const intervalId = setInterval(() => {
    explodeFromCenter(particlesPerBlast);

    for (let i = 0; i < 2; i++) {
      if (giftIndex < gifts.length) {
        animateGiftFromCenter(gifts[giftIndex]);
        giftIndex++;
      }
    }

    if (Date.now() - start >= durationMs) {
      clearInterval(intervalId);

      // 👉 Ẩn mượt intro và bật main
      const introEl = document.querySelector(".intro");

    if (introEl) {
  // 👉 Hiện main ngay khi bắt đầu mờ dần
  document.querySelector(".main")?.classList.add("active");
  document.querySelector(".MS__outer")?.classList.add("active");
document.querySelector(".floating_popup")?.classList.add("active");
  document.documentElement.classList.remove("close_scroll");
document.body.classList.remove("intro-active");

  let mainShown = false;

// gsap.to(introEl, {
//   opacity: 0,
//   duration: 1.2,
//   ease: "power2.out",
//   onUpdate: function () {
//     if (!mainShown && this.progress() >= 0) {
//       mainShown = true;
//       document.querySelector(".main")?.classList.add("active");
//       document.querySelector(".MS__outer")?.classList.add("active");
//       document.documentElement.classList.remove("close_scroll");
//     }
//   },
//   onComplete: () => {
//     introEl.remove();

//     // 👉 Cập nhật layout ngay sau khi remove intro
//     window.dispatchEvent(new Event("resize"));

//     initSwiper();
//   }
// });

gsap.to(introEl, {
  opacity: 0,
  duration: 0,
  ease: "power2.out",
  onStart: function () {
    document.querySelector(".main")?.classList.add("active");
    document.querySelector(".MS__outer")?.classList.add("active");
 document.querySelector(".floating_popup")?.classList.add("active");

    document.documentElement.classList.remove("close_scroll");
    document.body.classList.remove("intro-active"); // 👉 THÊM DÒNG NÀY
  },
  onComplete: () => {
    introEl.remove();
    window.dispatchEvent(new Event("resize"));
   // initSwiper();
  }
});
}
    }

  }, interval);
}

function animateGiftFromCenter(gift) {
  gsap.set(gift, {
    display: "block",
    opacity: 1,
    x: 0,
    y: 0,
    scale: 0.8
  });

  const angle = Math.random() * Math.PI * 2;
  const distance = 200 + Math.random() * 200;
  const x = Math.cos(angle) * distance;
  const y = Math.sin(angle) * distance;

  gsap.to(gift, {
    x,
    y,
    duration: 1.2,
    ease: "power2.out"
  });

  gsap.to(gift, {
    opacity: 0,
    duration: 1.2,
    delay: 0.3,
    ease: "power1.out",
    onComplete: () => {
      gift.style.display = "none";
    }
  });
}

function explodeFromCenter(count = 50) {
  const wrapper = document.querySelector(".confetti-wrapper");

  for (let i = 0; i < count; i++) {
    const particle = document.createElement("div");
    particle.classList.add("confetti-particle");

    const hue = Math.floor(Math.random() * 360);
    particle.style.backgroundColor = `hsl(${hue}, 90%, 60%)`;

    const minSize = 3;
    const maxSize = 10;
    const width = Math.floor(Math.random() * (maxSize - minSize)) + minSize;
    const height = width + Math.floor(Math.random() * 10);

    particle.style.width = `${width}px`;
    particle.style.height = `${height}px`;
    particle.style.borderRadius = `${Math.random() * 4}px`;

    wrapper.appendChild(particle);

    const angle = Math.random() * Math.PI * 2;
    const distance = 200 + Math.random() * 600;
    const x = Math.cos(angle) * distance;
    const y = Math.sin(angle) * distance;

    gsap.to(particle, {
      x,
      y,
      rotation: Math.random() * 720,
      scale: 0.8 + Math.random() * 1.5,
      opacity: 0,
      duration: 1.2 + Math.random(),
      ease: "power3.out",
      onComplete: () => particle.remove()
    });
  }
}

// function initSwiper() {
//   grArtSwiper = new Swiper(".gr_artSwiper", {
//     slidesPerView: 1,
//     spaceBetween: 0,
//     navigation: {
//       nextEl: ".swiper-button-next.artNext",
//       prevEl: ".swiper-button-prev.artPrev",
//     },
//     effect: "fade",
//     fadeEffect: {
//       crossFade: true,
//     },
//     loop: false,
//     autoplay: {
//       delay: 5000,
//       disableOnInteraction: false,
//     }
//   });
// }

